<template>
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator />

    <UMain>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UMain>

    <UNotifications />
</template>
